import store from '../../store';
var dragValidations = {
    readonly: {
        validator: function (item) { return true; },
        message: 'A feladat állapota nem módosítható!'
    }
};
var dropValidations = {
    statusChanged: {
        validator: function (item, target) { return item.statusId !== target; },
        message: 'A feladat már ebben a státuszban van!'
    }
};
var UserPolicy = /** @class */ (function () {
    function UserPolicy() {
    }
    UserPolicy.prototype.canDrag = function (item) {
        var fail = Object.keys(dragValidations)
            .find(function (key) { return !dragValidations[key].validator(item); });
        if (fail) {
            store.userStore.notify(dragValidations[fail].message);
        }
        return !fail;
    };
    UserPolicy.prototype.canDrop = function (item, target) {
        var fail = Object.keys(dropValidations)
            .find(function (key) { return !dropValidations[key].validator(item, target); });
        if (fail) {
            store.userStore.notify(dropValidations[fail].message);
        }
        return !fail;
    };
    return UserPolicy;
}());
var policy = new UserPolicy();
export default policy;



//////////////////
// WEBPACK FOOTER
// ./src/services/DragDropPolicy/UserPolicy.ts
// module id = 345
// module chunks = 0